import {Component, ViewEncapsulation} from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { HomePage } from "./modules/home/home.page";
import { Subscription } from "rxjs/Rx";
import { AppSpinnerService } from "./providers/app-spinner.service";
import { LoaderState } from "./interfaces/loader";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
    private subscription: Subscription;
    showLoader: boolean;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private spinnerService: AppSpinnerService,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
ngOnInit() {
    this.subscription = this.spinnerService.loaderState
        .subscribe((state: LoaderState) => {
            this.showLoader = state.show;
        });
}
ngOnDestroy() {
    this.subscription.unsubscribe();
}
}
